import { render } from "./nested-search.vue?vue&type=template&id=35bf2a64&scoped=true"
import script from "./nested-search.vue?vue&type=script&lang=js"
export * from "./nested-search.vue?vue&type=script&lang=js"

import "./nested-search.vue?vue&type=style&index=0&id=35bf2a64&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bf2a64"]])

export default __exports__